// import * as signalR from "@microsoft/signalr";
// import { createContext, useContext, useEffect, useRef, useState } from "react";
// import { useCookies } from "react-cookie";
// import { postData } from "../../services";

// const CommunityNotificationContext = createContext();

// export const CommmunityNotificationProvider = ({ children }) => {
//   const [cookies] = useCookies(["euid", "e_u"]);
//   const [allNotifications, setAllNotifications] = useState([]);
//   const [markAllAsRead, setMarkAllAsRead] = useState(false);
//   const baseURL = process.env.REACT_APP_NOTIFICATION_HUB_URL;
//   const connectionRef = useRef(null);

//   useEffect(() => {
//     if (!baseURL || !cookies.euid) return;
    
//     const connection = new signalR.HubConnectionBuilder()
//       .withUrl(baseURL, {
//         skipNegotiation: true,
//         transport: signalR.HttpTransportType.WebSockets,
//       })
//       .withAutomaticReconnect()
//       .build();

//     connection.start()
//       .then(() => console.log("SignalR connected"))
//       .catch(err => console.error("SignalR connection error:", err));

//     connection.on("ReceiveNotification", (notification) => {
//       if (notification?.employees_to_notify?.includes(cookies.euid)) {
//         setAllNotifications(prev => [notification, ...prev]);
//       }
//     });

//     connectionRef.current = connection;
    
//     return () => {
//       if (connection.state === signalR.HubConnectionState.Connected) {
//         connection.stop();
//       }
//     };
//   }, [baseURL, cookies.euid]);

//   // const markAsRead = async (notificationIds) => {
//   //   if (!notificationIds || notificationIds.length === 0) return;
    
//   //   try {
//   //     await postData({
//   //       endpoint: "Notification/markAsRead",
//   //       data: { notificationIds },
//   //       token: cookies.e_u,
//   //     });
      
//   //     setAllNotifications(prev => 
//   //       prev.map(notification => 
//   //         notificationIds.includes(notification.id)
//   //           ? { ...notification, isRead: true }
//   //           : notification
//   //       )
//   //     );
//   //   } catch (error) {
//   //     console.error("Error marking notifications as read:", error);
//   //   }
//   // };

//   return (
//     <CommunityNotificationContext.Provider
//       value={{ 
//         allNotifications, 
//         setMarkAllAsRead,
//         markAllAsRead,
//       }}
//     >
//       {children}
//     </CommunityNotificationContext.Provider>
//   );
// };

// export const useCommunityNotificationContext = () => 

  

import * as signalR from "@microsoft/signalr";
import { createContext, useContext, useEffect, useRef, useState } from "react";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import { postData } from "../../services";

const CommunityNotificationContext = createContext();

export const CommmunityNotificationProvider = ({ children }) => {
  const [cookies, setCookie, removeCookies] = useCookies(["euid", "e_u", "e_t", "buid"]);
  const [allNotifications, setAllNotifications] = useState([]);
  const [markAllAsRead, setMarkAllAsRead] = useState(false);
  const baseURL = process.env.REACT_APP_NOTIFICATION_HUB_URL;
  const connectionRef = useRef(null);
  const navigate = useNavigate();

  // Function to clear all cookies and redirect to login
  const handleEmployeeDelete = () => {
    // Clear all relevant cookies
    removeCookies("euid", { path: "/" });
    removeCookies("e_u", { path: "/" });
    removeCookies("e_t", { path: "/" });
    
    // Clear any other cookies that might exist
    // const allCookies = Object.keys(cookies);
    // allCookies.forEach(cookieName => {
    //   removeCookies(cookieName, { path: "/" });
    // });
    
    // Navigate to login page
    navigate("/");
  };

  useEffect(() => {
    if (!baseURL || !cookies.euid) return;
    
    const connection = new signalR.HubConnectionBuilder()
      .withUrl(baseURL, {
        skipNegotiation: true,
        transport: signalR.HttpTransportType.WebSockets,
      })
      .withAutomaticReconnect()
      .build();

    connection.start()
      .then(() => console.log("SignalR connected"))
      .catch(err => console.error("SignalR connection error:", err));

    connection.on("ReceiveNotification", (notification) => {
      if (notification?.employees_to_notify?.includes(cookies.euid)) {
        // Check if this is an employee delete notification
        
        if (notification?.type === "EmployeeDeleted") {
          handleEmployeeDelete();
          return; // Don't add to notifications as user will be logged out
        }
        
        // Add other notifications normally
        setAllNotifications(prev => [notification, ...prev]);
      }
    });

    connectionRef.current = connection;
    
    return () => {
      if (connection.state === signalR.HubConnectionState.Connected) {
        connection.stop();
      }
    };
  }, [baseURL, cookies.euid, navigate]);

  // const markAsRead = async (notificationIds) => {
  //   if (!notificationIds || notificationIds.length === 0) return;
    
  //   try {
  //     await postData({
  //       endpoint: "Notification/markAsRead",
  //       data: { notificationIds },
  //       token: cookies.e_u,
  //     });
      
  //     setAllNotifications(prev => 
  //       prev.map(notification => 
  //         notificationIds.includes(notification.id)
  //           ? { ...notification, isRead: true }
  //           : notification
  //       )
  //     );
  //   } catch (error) {
  //     console.error("Error marking notifications as read:", error);
  //   }
  // };

  return (
    <CommunityNotificationContext.Provider
      value={{ 
        allNotifications, 
        setMarkAllAsRead,
        markAllAsRead,
      }}
    >
      {children}
    </CommunityNotificationContext.Provider>
  );
};

export const useCommunityNotificationContext = () => 
  useContext(CommunityNotificationContext);
